import { takeEvery, call, put } from 'redux-saga/effects';
import { gcApi } from 'config/axios';
import {
    FETCH_DAILY_SLEEP_REPORT_DATA,
    FETCH_WEEKLY_SLEEP_REPORT_DATA,
    FETCH_SLEEP_REPORT_DATA_FETCHING,
    FETCH_SLEEP_REPORT_DATA_SUCCESS,
    FETCH_SLEEP_REPORT_DATA_FAIL
} from '../actions/ActionTypes';

// Workers
export function* fetchDailySleepReportDataSaga(action) {
    try {
        yield put({
            type: FETCH_SLEEP_REPORT_DATA_FETCHING
        });

        const { startDate, endDate } = action.payload;
        const response = yield call(gcApi.get, `sleep-service/stats/sleep/daily/${startDate}/${endDate}`);

        yield put({
            type: FETCH_SLEEP_REPORT_DATA_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_SLEEP_REPORT_DATA_FAIL,
            data: null
        });
    }
}

export function* fetchWeeklySleepReportDataSaga(action) {
    try {
        yield put({
            type: FETCH_SLEEP_REPORT_DATA_FETCHING
        });

        const { endDate } = action.payload;
        const response = yield call(gcApi.get, `sleep-service/stats/sleep/weekly/${endDate}/52`);

        yield put({
            type: FETCH_SLEEP_REPORT_DATA_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_SLEEP_REPORT_DATA_FAIL,
            data: null
        });
    }
}

// Watcher
export const sleepReportSagas = [
    takeEvery(FETCH_DAILY_SLEEP_REPORT_DATA, fetchDailySleepReportDataSaga),
    takeEvery(FETCH_WEEKLY_SLEEP_REPORT_DATA, fetchWeeklySleepReportDataSaga)
];
